import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Assessments from "./routes/Assessments";
import LearningGoals from "./routes/LearningGoals";
import Standards from "./routes/Standards";
import FinalGrades from "./routes/FinalGrades";

export default store => ({
  path: "gradebook",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-gradebook" */ "./components"),
        import(
          /* webpackChunkName: "course-gradebook" */ "Worksheet/modules/WorksheetModules"
        ),
        import(
          /* webpackChunkName: "course-gradebook" */ "./modules/GradebookModule"
        ),
        import(
          /* webpackChunkName: "course-gradebook" */ "AppComponents/ProgressSummaryV2Shared/modules/ClassProgressSummaryModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const worksheetModule = importedModule1;
          const reducer = importedModule2.default;
          const progressSummaryReducer = importedModule3.default;
          injectReducer(store, {
            key: worksheetModule.NAME,
            reducer: worksheetModule.default,
          });
          injectReducer(store, {
            key: "gradebook",
            reducer,
          });
          injectReducer(store, {
            key: "classProgressSummaryV2",
            reducer: progressSummaryReducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    Assessments(store),
    LearningGoals(store),
    Standards(store),
    FinalGrades(store),
  ],
});
